const CURRENT_KEY = 'atlasAccessToken';
const LEGACY_KEY = 'macroAccessToken';

/** Copy before removing the old record; a quota failure must not lose a session. */
export function sessionStorageName(): string {
  let name = CURRENT_KEY;
  try {
    const storage = globalThis.localStorage;
    if (storage.getItem(CURRENT_KEY) !== null) {
      storage.removeItem(LEGACY_KEY);
      return CURRENT_KEY;
    }
    const legacy = storage.getItem(LEGACY_KEY);
    if (legacy !== null) {
      name = LEGACY_KEY;
      storage.setItem(CURRENT_KEY, legacy);
      name = CURRENT_KEY;
      storage.removeItem(LEGACY_KEY);
    }
  } catch {
    // Keep using the readable record when storage is unavailable or full.
  }
  return name;
}
